import React, { FC } from "react";
import { TableFooter as MuiTableFooter } from "@mui/material";

type Props = React.ComponentProps<typeof MuiTableFooter>;

const TableFooter: FC<Props> = (props) => {
    return <MuiTableFooter {...props}/>
}

export default TableFooter;